
<div class="status">
  <indicator :size=8 :fill="eventSourcesColor" class="status-indicator" />
  <span class="item" :title="disconnectedEventSources.map(s=>`${s.name} disconnected`).join('\n')">Source</span>
  <indicator :size=8 :fill="configColor" class="status-indicator" />
  <span class="item" :title="Object.values(configReasons).join('\n')">Config</span>
</div>
